import React, { useState } from "react"
import PropTypes from "prop-types"
import APIS from "../../apis"
import { Col, Input, Row, Label, Form, Button, CardTitle } from "reactstrap"
import { ToastContainer, toast, Slide } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { withTranslation } from "react-i18next"
import { withRouter } from "react-router"

const AttestationPresence = props => {
  const userAuthEtudiant = JSON.parse(localStorage.getItem("userAuthEtudiant") || "{}")
  const etudiant_id = userAuthEtudiant?.user?.id_etudiant
  const annee_id = userAuthEtudiant?.user?.annee_id

  const [raison, setRaison] = useState("")
  const [selectLangue, setSelectLangue] = useState([]) // [{ value: 1, label: 'Français' }]
  const [nbCopieAr, setNbCopieAr] = useState(0)
  const [nbCopieFr, setNbCopieFr] = useState(0)

  const languesDisponibles = [
    { value: 1, label: "Français" },
    { value: 2, label: "Arabe" },
  ]

  // ✅ Gestion des checkbox avec objets complets
  const handleCheckboxChange = (langue) => {
    // Remise à zéro du compteur si décochée
    if (langue.value === 1) setNbCopieFr(0)
    if (langue.value === 2) setNbCopieAr(0)

    setSelectLangue((prev) => {
      const exists = prev.find(l => l.value === langue.value)
      if (exists) {
        // Si la langue est déjà cochée → on la retire
        return prev.filter(l => l.value !== langue.value)
      } else {
        // Sinon → on l’ajoute
        return [...prev, langue]
      }
    })
  }

  const save = async () => {
    if (raison.trim() === "") {
      toast.error("⛔ Raison obligatoire !", { containerId: "A" })
      return
    }

    if (selectLangue.length === 0) {
      toast.error("⛔ Langue obligatoire !", { containerId: "A" })
      return
    }

    try {
      const res = await APIS.post("etudiant/demande/add", {
        id: etudiant_id,
        attestation_id: 1,
        raison,
        langue: selectLangue, // ✅ renvoie [{label, value}, ...]
        annee_id,
        nb_copies_fr: nbCopieFr,
        nb_copies_ar: nbCopieAr,
      })

      if (res.data.errNum === 404 || res.data.errNum === "404") {
        toast.error("⛔ " + res.data.msg, { containerId: "A" })
      } else {
        props.history.push("/Demands")
      }
    } catch (error) {
      toast.error("Erreur lors de l’envoi de la demande", { containerId: "A" })
    }
  }

  return (
      <React.Fragment>
        <Row>
          <CardTitle className="h4">{props.t("Attestation de présence")}</CardTitle>
          <h2 style={{ color: "red" }}>
            {"Il est autorisé de soumettre une seule demande par semaine. Le nombre maximal de copies par langue est limité à 3."}
          </h2>

          <Form className="mt-4">
            <Row>
              {/* ✅ Langues (checkboxes) */}
              <Col md={4}>
                <div className="d-flex flex-column">
                  {languesDisponibles.map((langue) => (
                      <Label check key={langue.value}>
                        <Input
                            type="checkbox"
                            checked={!!selectLangue.find(l => l.value === langue.value)}
                            onChange={() => handleCheckboxChange(langue)}
                        />{" "}
                        {langue.label}
                      </Label>
                  ))}
                </div>
              </Col>

              {/* Champs conditionnels */}
              {selectLangue.find(l => l.value === 1) && (
                  <Col lg="4">
                    <div className="mb-3">
                      <Label>{props.t("Nombre de copie français")}</Label>
                      <Input
                          type="number"
                          className="form-control"
                          placeholder={props.t("Nombre de copie français")}
                          value={nbCopieFr}
                          min={1}
                          max={3}
                          onChange={e => {
                            const value = Number(e.target.value)
                            if (value >= 1 && value <= 3) setNbCopieFr(value)
                          }}
                      />
                    </div>
                  </Col>
              )}

              {selectLangue.find(l => l.value === 2) && (
                  <Col lg="4">
                    <div className="mb-3">
                      <Label>{props.t("Nombre de copie arabe")}</Label>
                      <Input
                          type="number"
                          className="form-control"
                          placeholder={props.t("Nombre de copie arabe")}
                          value={nbCopieAr}
                          min={1}
                          max={3}
                          onChange={e => {
                            const value = Number(e.target.value)
                            if (value >= 1 && value <= 3) setNbCopieAr(value)
                          }}
                      />
                    </div>
                  </Col>
              )}
            </Row>

            {/* Raison */}
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <Label>{props.t("Raison")}</Label>
                  <Input
                      type="textarea"
                      className="form-control"
                      placeholder={props.t("Raison")}
                      onChange={e => setRaison(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
          </Form>

          {/* Boutons */}
          <div className="d-flex justify-content-center">
            <Col lg="6" className="text-end mt-4">
              <Button
                  type="button"
                  color="warning"
                  className="btn btn-warning mb-2 me-2"
                  onClick={() => props.history.push("/Demands")}
              >
                {props.t("Annuler")}
              </Button>
            </Col>
            <Col lg="6" className="text-start mt-4">
              <Button type="button" color="primary" onClick={save}>
                {props.t("Confirmer")}
              </Button>
            </Col>
          </div>
        </Row>

        <ToastContainer
            transition={Slide}
            enableMultiContainer
            containerId={"A"}
            position={toast.POSITION.TOP_RIGHT}
            autoClose={2500}
        />
      </React.Fragment>
  )
}

AttestationPresence.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(AttestationPresence))
